import HeaderActions from 'app/src/layouts/HeaderActions'
import EditMyInfos from 'app/src/me/EditMyInfos'

export const Component = () => {
  return (
    <>
      <HeaderActions />
      <EditMyInfos />
    </>
  )
}
export default Component
